export interface Package {
  id: number;
  name: string;
  days: number;
  price: string;
  description?: string;
  image?: string;
  isActive: boolean; // required
}

export const getPackages = async (): Promise<Package[]> => {
  try {
    const res = await fetch("https://www.dreamstriphub.com/api/Packages_api.php");
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);

    const data = await res.json();

    return data.map((p: any) => ({
      id: parseInt(p.Id, 10),
      name: p.Name,
      days: parseInt(p.Days, 10),
      price: p.Price,
      description: p.Description,
      image: p.Image
        ? p.Image.startsWith("http")
          ? p.Image
          : `https://www.dreamstriphub.com${p.Image}`
        : undefined,
      isActive: p.IsActive === 1,
    }));
  } catch (error) {
    console.error("Error fetching packages:", error);
    return [];
  }
};
